import { Injectable } from '@angular/core';

export interface contextMenuOptions {
	name: string;
	disabled: boolean;
	type?: 'button' | 'link';
	//For type button
	event?: Function;
	//For type link
	url?: string;
}

@Injectable({
	providedIn: 'root',
})
export class ContextMenuService {
	constructor() {}

	private _contextMenuOptions: contextMenuOptions[] = [];
	private _displayContextMenu = false;
	private _startX = 0;
	private _startY = 0;

	public contextMenuData: any;
	public setContextMenuData(data: any): void {
		this.contextMenuData = data;
	}

	public setContextMenuOptions(menuOptions: contextMenuOptions[]): void {
		this._contextMenuOptions = menuOptions;
	}

	public addContextMenuOptions(name: string, event: Function, disabled: boolean = false): void {
		this._contextMenuOptions.push({
			name: name,
			event: event,
			disabled: disabled,
		});
	}

	public openContextMenu(x?: number, y?: number, offset?: number): void {
		// if(this.contextMenuOptions.length > 0)
		setTimeout(() => {
			document.addEventListener(
				'click',
				() => {
					if (this._displayContextMenu == true) {
						this.cleanContextMenu();
					}
				},
				{ once: true }
			);
		}, 10);

		this._displayContextMenu = true;
		if (x) this._startX = x + offset;
		if (y) this._startY = y + offset;
	}

	get displayContextMenu(): boolean {
		return this._displayContextMenu;
	}

	get x(): number {
		return this._startX;
	}

	get y(): number {
		return this._startY;
	}

	get contextMenuOptions(): contextMenuOptions[] {
		return this._contextMenuOptions;
	}

	public cleanContextMenu(): void {
		this._contextMenuOptions = [];
		this._displayContextMenu = false;
	}
}
